(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-breeds"]) return;
  try {
    
  document.querySelectorAll('.collection-breeds__breed-chooser select').forEach(select => {
    select.addEventListener('change', function() {
      window.location.href = this.value
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  let form = document.querySelector('.footer__newsletter')
  let formUrl = form.getAttribute('data-url')
  let checkboxInput = document.querySelector('input[type="checkbox"]')
  let checkboxVal = "FALSE";
  const dataPrivacyLabel = document.querySelector('.footer__data-privacy')

  const handleCheckboxChange = (event) => {
    let isChecked = event.target.checked;

    if (isChecked) {
      checkboxVal = "TRUE"
    }
  };

  checkboxInput.addEventListener('change', handleCheckboxChange)

  const onSubmit = evt => {
    evt.preventDefault();

    form = document.querySelector('.footer__newsletter')
    formUrl = form.getAttribute('data-url')
    const email = form.querySelector('input[type="email"]').value

    fetch(formUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, data_privacy: checkboxVal }),
    })

    form.classList.add('submitted')
    dataPrivacyLabel.style.display = "none"
  }

  form.addEventListener('submit', onSubmit)

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', evt => {
      if (evt.detail.sectionId === 'footer') {
        form.addEventListener('submit', onSubmit)
      }
    })

    document.addEventListener('shopify:section:unload', evt => {
      if (evt.detail.sectionId === 'footer') {
        form.removeEventListener('submit', onSubmit)
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
